import { render, staticRenderFns } from "./VxTableBody.vue?vue&type=template&id=1c98dc72&scoped=true&"
import script from "./VxTableBody.vue?vue&type=script&lang=js&"
export * from "./VxTableBody.vue?vue&type=script&lang=js&"
import style0 from "./VxTableBody.vue?vue&type=style&index=0&id=1c98dc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98dc72",
  null
  
)

export default component.exports